import React from 'react'

const Dropdown = ({ register, name, requiredMessage, dataList, placeholder }) => {
    return (
        <select
            className="flex-1 select2 shrink self-stretch my-auto basis-0 px-4 py-2.5 outline-primary rounded-md capitalize text-base"
            {...register(name, { required: requiredMessage })}
        >
            <option value="">{placeholder}</option>
            {dataList?.map((data) => (
                <option key={data._id} value={data._id}>
                    {data.name}
                </option>
            ))}
        </select>
    )
}

export default Dropdown